"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAffiliationDisplay = exports.Affiliations = exports.AffiliationMap = exports.ArtistSizes = exports.ArtistSignupSteps = void 0;
const utils_1 = require("../utils");
// TODO: Incomplete typings
exports.ArtistSignupSteps = [
    "email",
    "artistSearch",
    "artistConfirm",
    "artistAffiliation",
    "contactInfo",
    "additionalInfo",
    "verificationSent",
    "enterPhone",
    "verifyPhone",
    "requestSent",
    "accountCreated",
];
exports.ArtistSizes = ["tiny", "small", "medium", "large"];
exports.AffiliationMap = {
    artist: "Artist",
    "management-company": "Management Rep",
    marketing: "Marketing Rep",
    label: "Label Rep",
    crew: "Tour Crew Rep",
    other: "Other",
};
exports.Affiliations = (0, utils_1.enumKeys)(exports.AffiliationMap);
/**
 * Safely get `AffiliationDisplay` from a string or undefined value.  If the
 * provided `affiliation` can't be mapped onto an `AffiliationDisplay` then
 * this returns a default ("Other").
 */
const getAffiliationDisplay = (affiliation) => {
    if (affiliation && affiliation in exports.AffiliationMap) {
        exports.AffiliationMap[affiliation];
    }
    return "Other";
};
exports.getAffiliationDisplay = getAffiliationDisplay;
//# sourceMappingURL=types.js.map